import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.scss'
import App from './App';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { NotificationSnackbar, NotificationProvider } from './providers/notification';
import reportWebVitals from './reportWebVitals';
import { persistor, store } from './providers/store'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react';
import "react-datepicker/dist/react-datepicker.css";

const root = createRoot(
  document.getElementById('root') as HTMLElement
);
const queryClient = new QueryClient();

root.render(

 <React.StrictMode>
<NotificationProvider>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <QueryClientProvider client={queryClient}>
       <App/>
        <NotificationSnackbar />
      </QueryClientProvider>
    </PersistGate>
  </Provider>
</NotificationProvider>
</React.StrictMode> 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
